import { Shimmer, LoadingFloating } from "./Loading.styles"
import Spinner from "./Spinner"

const Loadable = ({ loading, loader = <Shimmer />, floating = false, children }) => {
    if (floating && loading) {
        return (
            <LoadingFloating>
                <Spinner size="20px" />
            </LoadingFloating>
        )
    }

    return loading
        ? loader
        : children
}

export default Loadable